module.exports = __webpack_public_path__ + "static/media/alpha_9.4062bc1d.png";